import React from "react"
import AutomationIdCheckForm, { AutomationIdCheckOTPForm } from "./AutomationIdCheckForm"
import AutomationDontSubmitSection from "./AutomationDontSubmitSection"
import AutomationEmailSection from "./AutomationEmailSection"
import { Button } from "@mui/material"
import AutomationRefCodesSection from "./AutomationRefCodesSection"


export default function AutomationConfirmFormSection ({
    automationOption,
    automationData,
    hidden = true,
    onCancel = () => {},
    onSubmit = (values) => {}
}) {

    if (hidden) return <></>

    if (automationOption.navigation_style === "cos_sms") {
        return (
            <AutomationDontSubmitSection 
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} />
        )
    }

    if (automationOption.navigation_style === "home_office_classic") {
        return (
            <AutomationRefCodesSection
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} 
                automationData={automationData} />
        )
    }

    if (automationOption.navigation_style === "home_office_dashboard") {
        return (
            <HomeOfficeDashboardSection 
                onSubmit={async (values) => await onSubmit(values)} 
                onCancel={onCancel} 
                automationOption={automationOption} 
                automationData={automationData} />
        )
    }

    // Fall back to just a submit button, if navigation style is not recognised.
    return (
        <Button 
            className="btn btn-sm" 
            variant="contained" 
            color="success" 
            onClick={() => onSubmit({})}>
            Start {automationOption.navigation_style} automation
        </Button>
    )
}


function HomeOfficeDashboardSection ({
    automationOption,
    automationData,
    onCancel = () => {},
    onSubmit = async (values) => {}
}) {
    
    const [idCheckValues, setIdCheckValues] = React.useState(null)

    return (
        <>
            <AutomationIdCheckForm
                hidden={idCheckValues}
                onCancel={() => onCancel()}
                onSubmit={(values) => setIdCheckValues(values)} />

            <AutomationRefCodesSection 
                includeSubjectEmail={false}
                hidden={!idCheckValues}
                onSubmit={async (values) => await onSubmit({...idCheckValues, ...automationData, ...values})} 
                onCancel={() => setIdCheckValues(null)} 
                automationOption={automationOption} 
                automationData={automationData} />
        </>
    )
}